import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { User } from 'src/app/models/user.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';

@Component({
    selector: 'que-selected-users',
    imports: [CommonModule,
        // MatFormFieldModule,
        // MatInputModule,
        TranslateDirective, TranslatePipe,
        // MatAutocompleteModule,
        MiniContactDisplayComponent,
        ReactiveFormsModule,
    ],
    templateUrl: './selected-users.component.html',
    styleUrls: ['./selected-users.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedUsersComponent implements OnInit {
  myControl = new FormControl('');
  @Input() usersInput?: User[];
  @Output() selectUserEvent = new EventEmitter<number[]>();

  users$ = signal<User[]>([]);
  selectedUsers$ = signal<number[]>([]);
  filterValue$ = toSignal(this.myControl.valueChanges)
  isSelectAll$ = computed(()=>this.selectedUsers$()?.length==this.users$()?.length)
  filterUsers$ = computed(() => {
    var value = this.filterValue$()?.toLocaleLowerCase() ?? "";
    var x = this.users$().filter(u => {
      var name1 = `${u.firstName} ${u.lastName}`;
      var name2 = `${u.lastName} ${u.firstName}`;

      return name1.toLocaleLowerCase().includes(value) || name2.toLocaleLowerCase().includes(value) || u.email?.toLocaleLowerCase().includes(value);

    }).map(u => {
      return { user: u, selected: this.selectedUsers$().includes(u.id) }
    });
    return x;
  })

  /**
   *
   */
  constructor() {
    effect(() => {
      this.selectUserEvent.emit(this.selectedUsers$())
    })
  }
  ngOnInit(): void {
    if (this.usersInput) {
      this.users$.set(this.usersInput);
    }
  }

  onContactSelected(u: { user: User, selected: boolean }): void {
    if (u.selected) {
      this.selectedUsers$.set([...this.selectedUsers$().filter(x => x != u.user.id)])
    } else {
      this.selectedUsers$.set([...this.selectedUsers$(), u.user.id])
    }
  }
  selectAll() {
    if (!this.isSelectAll$()) {
      this.selectedUsers$.set([...this.users$().map(u => u.id)]);
    }
    else{
      this.selectedUsers$.set([]);
    }
  }
}
